import type { HealthState, LogLevel } from '@monitor/contracts';

// Color follows the entity, never its rank: a Provider keeps its hue on every screen.
// Slot order is the validated categorical order; slot 6 (green) is skipped for Providers so a
// series never looks like the "good" status.
const PROVIDER_SLOT: Record<string, number> = { azure: 1, cloudflare: 2, google: 3, openai: 4, anthropic: 6, resend: 5, meta: 7 };

export const providerColor = (id: string) => `var(--series-${PROVIDER_SLOT[id] ?? 8})`;

export const PROVIDER_MONOGRAM: Record<string, string> = {
  azure: 'Az',
  google: 'G',
  cloudflare: 'CF',
  openai: 'AI',
  anthropic: 'An',
  resend: 'Re',
  meta: 'Wa',
};

/** Visible Provider names, used where only the id is at hand. */
export const PROVIDER_NAME: Record<string, string> = {
  azure: 'Azure',
  google: 'Google',
  cloudflare: 'Cloudflare',
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  resend: 'Resend',
  meta: 'Meta',
};

/** Series for arbitrary keys (applications, services): assigned in order, max 8 then "other". */
export function seriesColor(index: number) {
  return index < 8 ? `var(--series-${index + 1})` : 'var(--series-other)';
}

export const STATE_COLOR: Record<HealthState, string> = {
  Healthy: 'var(--good)',
  Degraded: 'var(--warning)',
  Unhealthy: 'var(--critical)',
  Unknown: 'var(--unknown)',
};

export const LEVEL_COLOR: Record<LogLevel, string> = {
  Trace: 'var(--text-4)',
  Debug: 'var(--unknown)',
  Information: 'var(--series-1)',
  Warning: 'var(--warning)',
  Error: 'var(--serious)',
  Critical: 'var(--critical)',
};
